import React, { useEffect } from 'react';
import { initMetaPixel } from './lib/metaPixel';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero, SocialProof, PainPoints, ProductIntro, Tomes, Bonuses } from './components/Sections';
import { Pricing, OrderBump, Comparison, Testimonials, Guarantee, FAQ, Footer } from './components/PricingFAQ';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-white font-sans selection:bg-purple-200 selection:text-purple-900" data-id="element-0">
      <PurchasePopup data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <SocialProof data-id="element-4" />
        <PainPoints data-id="element-5" />
        <ProductIntro data-id="element-6" />
        <Tomes data-id="element-7" />
        <Bonuses data-id="element-8" />
        <Pricing data-id="element-9" />
        <OrderBump data-id="element-10" />
        <Comparison data-id="element-11" />
        <Testimonials data-id="element-12" />
        <Guarantee data-id="element-13" />
        <FAQ data-id="element-14" />
      </main>

      <Footer data-id="element-15" />
    </div>;
}